import React, { useState } from "react";
import { heroImage, officeStaff, supervisor } from "./img";
import OfficeStaffPopUp from "./PopUpComponents/officeStaff";
import SupervisorPopUp from "./PopUpComponents/supervisor";
import "./nonTech.css";

function NonTeachingStaff() {
  const [displayOfficeStaffPopUp, setDisplayOfficeStaffPopUp] = useState(false);
  const [displaySupervisorPopUp, setDisplaySupervisorPopUp] = useState(false);

  const handlePopupClick = () => {
    if (displayOfficeStaffPopUp || displaySupervisorPopUp) {
      setDisplayOfficeStaffPopUp(false);
      setDisplaySupervisorPopUp(false);
    }
  };

  return (
    <div style={{ marginBottom: "150px" }} onClick={handlePopupClick}>
      <div style={{ position: "relative", width: "95vw" }} className="ml-0 sm:ml-[40px]">
        {/* PopUp components */}
        {displayOfficeStaffPopUp && <OfficeStaffPopUp status={setDisplayOfficeStaffPopUp} />}
        {displaySupervisorPopUp && <SupervisorPopUp status={setDisplaySupervisorPopUp} />}
        {/* main page */}
        <div className="container">
          <img src={heroImage} alt="heroImage" />
        </div>
        <div className="grid sm:grid-cols-2 mx-5 my-5 sm:px-10 sm:mx-[100px] sm:my-10 gap-5 nonTech">
          <div style={style.card} onClick={() => setDisplayOfficeStaffPopUp(true)}>
            <img src={officeStaff} style={style.peopleDivImg} alt="officeStaff" />
          </div>
          <div style={style.card} onClick={() => setDisplaySupervisorPopUp(true)}>
            <img src={supervisor} style={style.peopleDivImg} alt="supervisor" />
          </div>
        </div>
      </div>
    </div>
  );
}

const style = {
  card: {
    borderRadius: "30px",
    backgroundRepeat: "no-repeat",
    display: "flex",
    flexShrink: "1",
    justifyContent: "center",
    alignItems: "center",
    position: "relative",
  },
  peopleDivImg: {
    width: "100%",
  },
};

export default NonTeachingStaff;

